// myThesisList.js
import request from '@/utils/request';

export function getMyThesisList(params) {
  return request({
    url: '/v1/user_info/manuscript_info',
    method: 'get',
    params: params,
  });
}

export function deleteManuscript(manuscript_id) {
  return request({
    url: `/v1/user_info/manuscript_info/${manuscript_id}`,
    method: 'DELETE',
  });
}
